import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import distanceInWordsStrict from 'date-fns/distance_in_words_strict';
import differenceInCalendarDays from 'date-fns/difference_in_calendar_days';
import format from 'date-fns/format';
import ruLocale from 'date-fns/locale/ru';

import { formatCurrency } from 'utils/formatString';

import styles from './styles.pcss';

export const cx = classNames.bind(styles);

const RateCost = ({
  rate,
  priceNote,
  priceDescription,
  currency,
  ratePeriod = 'в месяц',
  rateDate,
  showRateDate,
  isMobile,
}) => (
  <>
    {!!priceDescription && (
    <div className={cx('rate-cost')}>
      {priceDescription}
    </div>
    )}
    {typeof rate === 'number' && (
    <>
      <div className={cx('rate-cost')}>
        {rate}
        {' '}
        {formatCurrency(currency)}
        {!isMobile && <br />}
        {' '}
        {ratePeriod}
      </div>
      {showRateDate && rateDate && (
      <div className={cx('rate-date')}>
        Следующее списание
        <br />
        {differenceInCalendarDays(new Date(rateDate), new Date()) < 7
          ? ` через ${distanceInWordsStrict(new Date(), new Date(rateDate), { locale: ruLocale })}`
          : format(rateDate, 'DD.MM.YYYY')}
      </div>
      )}
    </>
    )}
    {priceNote && (
    <div
      className={cx('rate-description')}
      dangerouslySetInnerHTML={{ __html: priceNote }}
    />
    )}
  </>
);

RateCost.propTypes = {
  rate: PropTypes.number.isRequired,
  ratePeriod: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  rateDate: PropTypes.string,
  priceNote: PropTypes.string,
  priceDescription: PropTypes.string,
  currency: PropTypes.string.isRequired,
  showRateDate: PropTypes.bool,
  isMobile: PropTypes.bool,
};

export default RateCost;
